/**
 * 指定两位置的元素互换位置
 *
 * @param {array} arr 原数组
 * @param {number} index1 添加项目的位置
 * @param {number} index2 删除项目的位置
 */
export function swapArray(arr, index1, index2) {
  // es5
  // arr[index1] = arr.splice(index2, 1, arr[index1])[0];

  // es6
  ;[arr[index1], arr[index2]] = [arr[index2], arr[index1]]
  return arr
}

/**
 * 制定位置元素向前移动一位
 *
 * @param {array} arr 原数组
 * @param {number} index1 要往数组头部的位置
 */
export function zIndexUp(arr, index1) {
  index1 = index1 * 1
  if (index1 != 0) {
    return swapArray(arr, index1, index1 - 1)
  } else {
    console.log('已置顶了')
    return arr
  }
}

export function zIndexDown(arr, index1) {
  index1 = index1 * 1

  if (index1 + 1 != arr.length) {
    return swapArray(arr, index1, index1 + 1)
  } else {
    console.log('已到底了')
    return arr
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js